export var FileSystemAccessMode;
(function (FileSystemAccessMode) {
    FileSystemAccessMode[FileSystemAccessMode["READ_WRITE"] = 0] = "READ_WRITE";
    FileSystemAccessMode[FileSystemAccessMode["READ_ONLY"] = 1] = "READ_ONLY";
})(FileSystemAccessMode || (FileSystemAccessMode = {}));
